import { isApiError } from "@pandas/http-client";
import logger from "@/lib/logging/logger";
import { useStore } from "@/store";

export const getErrorMessage = (e: unknown): string | undefined => {
	if (isApiError(e)) return e.errorCode;
	if (e instanceof Error) return e.message;
	return undefined;
};

export const setErrorMessage = (e: unknown, logMessage: string) => {
	const setError = useStore.getState().setError;
	const error = getErrorMessage(e);
	if (!isApiError(e)) logger.error("FLOW", logMessage, e);
	setError(error);
};
